import React from 'react'

interface IProps {
	width?: number | 'auto' | string
	height?: number | 'auto' | string
	resizeMode?: 'cover' | 'contain' | 'stretch' | 'repeat' | 'center'
	src?: any
	alt?: string
	style?: any
	onClick?: () => void
  loading?: 'eager' | 'lazy'
}

const CImage = ({
	src,
	alt,
	width,
	height,
	resizeMode,
	style,
	onClick,
  loading = 'lazy',

}: IProps) => {
	return (
		<img
			src={src}
			alt={alt ? alt : 'random'}
			width={width}
			height={height}
			loading={loading}
			style={{ backgroundSize: resizeMode, ...style, 
			 }}
			onClick={onClick}
		/>
	)
}

export default React.memo(CImage)
